import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion";
import useOutsideClick from "../../effects/use-OutsideClick.effect.jsx";
import { Card } from "@/components/ui/card";

export default function Notifications({ ...props }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const open = useSelector((state) => state.layout.notificationsOpen);
  const notifications = useSelector((state) => state.layout.notifications);

  const wrapperRef = React.useRef(null);
  useOutsideClick(wrapperRef, { type: "CLOSE_NOTIFICATIONS" }, dispatch);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          ref={wrapperRef}
          initial={{ x: -700, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: -700, opacity: 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          className="fixed left-15 bottom-0 z-50"
          {...props}
        >
          <Card className="w-[700px] h-[70vh] min-h-max border border-blue-600 bg-white shadow-xl">
            <div className="p-5 pb-2 mb-2 border-b border-gray-200">
              <h5 className="text-xl font-bold text-blue-600">
                {t("dashboard.drawer.notifications")}
              </h5>
            </div>
            
            <div className="overflow-y-auto h-full" dir="ltr">
              {notifications.map((notification, index) => (
                <div
                  key={notification || index}
                  className="py-6 px-5 border-b border-gray-300 bg-gray-50 font-semibold text-lg text-gray-900"
                >
                  component to implement a popover behavior based on the mouse
                  over event.
                </div>
              ))}
            </div>
          </Card>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
